import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FilterCountService {
  sharedValue$ = new BehaviorSubject(0);
}
